import { NiaraIcon } from '@niaratech/niara-icons';
import React from 'react';
import { useTheme } from 'styled-components';
import * as S from './styles';
export type DateCheckProps = {
  startDate: string;
  endDate: string;
  withTitle?: boolean;
  isDisable?: boolean;
};
const DateCheck: React.FC<DateCheckProps> = ({
  startDate,
  endDate,
  withTitle,
  isDisable
}) => {
  const theme = useTheme();
  return <S.Dates alignItem={withTitle}>
      <S.DatesCheck>
        {withTitle && <label>Check-in</label>}
        <p>{startDate}</p>
      </S.DatesCheck>

      <S.Separator>
        <NiaraIcon size={14} color={isDisable ? theme?.colors?.gray5 : theme?.colors?.primary} icon="sysApplyArrow" />
      </S.Separator>

      <S.DatesCheck>
        {withTitle && <label>Check-out</label>}
        <p>{endDate}</p>
      </S.DatesCheck>
    </S.Dates>;
};
export default DateCheck;